import React from "react";

function Header({ children }) {
  return (
    <>
      <thead className="text-xs font-medium text-gray-500 bg-gray-100 border-b border-line-strong dark:bg-gray-900 dark:text-gray-400 dark:border-gray-600">
        {children}
      </thead>
    </>
  );
}

Header.displayName = "Table.Header";

export default Header;
